"use strict";

var _regeneratorRuntime = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var universal_authenticator_library_1 = require("universal-authenticator-library");

var UALAnchorError_1 = require("./UALAnchorError");

var AnchorUser =
/*#__PURE__*/
function (_universal_authentica) {
  _inherits(AnchorUser, _universal_authentica);

  function AnchorUser(rpc, session) {
    var _this;

    _classCallCheck(this, AnchorUser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorUser).call(this));
    _this.accountName = '';
    _this.requestPermission = '';
    _this.chainId = session.link.chainId;
    _this.accountName = session.auth.actor;
    _this.requestPermission = session.auth.permission;
    _this.session = session;
    _this.rpc = rpc;
    return _this;
  }

  _createClass(AnchorUser, [{
    key: "signTransaction",
    value: function signTransaction(transaction, options) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var completedTransaction, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.session.transact(transaction, options);

              case 3:
                completedTransaction = _context.sent;
                return _context.abrupt("return", this.returnEosjsTransaction(options.broadcast, completedTransaction));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                message = _context.t0.message ? _context.t0.message : 'Unable to sign transaction';
                type = universal_authenticator_library_1.UALErrorType.Signing;
                cause = _context.t0;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }, {
    key: "signArbitrary",
    value: function signArbitrary(publicKey, data, _) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("signArbitrary", publicKey, data);
                throw new UALAnchorError_1.UALAnchorError("Anchor does not currently support signArbitrary", universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "verifyKeyOwnership",
    value: function verifyKeyOwnership(challenge) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("verifyKeyOwnership", challenge);
                throw new UALAnchorError_1.UALAnchorError("Anchor does not currently support verifyKeyOwnership", universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "getAccountName",
    value: function getAccountName() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.accountName);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getChainId",
    value: function getChainId() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.chainId);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var keys, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("getKeys");
                _context6.prev = 1;
                _context6.next = 4;
                return this.signatureProvider.getAvailableKeys(this.requestPermission);

              case 4:
                keys = _context6.sent;
                return _context6.abrupt("return", keys);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](1);
                message = "Unable to getKeys for account ".concat(this.accountName, ".\n        Please make sure your wallet is running.");
                type = universal_authenticator_library_1.UALErrorType.DataRequest;
                cause = _context6.t0;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 8]]);
      }));
    }
  }, {
    key: "isAccountValid",
    value: function isAccountValid() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var account, actualKeys, authorizationKeys, message, type, cause;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log("isAccountValid");
                _context7.prev = 1;
                _context7.t0 = this.rpc;

                if (!_context7.t0) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 6;
                return this.rpc.get_account(this.accountName);

              case 6:
                _context7.t0 = _context7.sent;

              case 7:
                account = _context7.t0;
                actualKeys = this.extractAccountKeys(account);
                _context7.next = 11;
                return this.getKeys();

              case 11:
                authorizationKeys = _context7.sent;
                return _context7.abrupt("return", actualKeys.filter(function (key) {
                  return authorizationKeys.indexOf(key) !== -1;
                }).length > 0);

              case 15:
                _context7.prev = 15;
                _context7.t1 = _context7["catch"](1);

                if (!(_context7.t1.constructor.name === 'UALAnchorError')) {
                  _context7.next = 19;
                  break;
                }

                throw _context7.t1;

              case 19:
                message = "Account validation failed for account ".concat(this.accountName, ".");
                type = universal_authenticator_library_1.UALErrorType.Validation;
                cause = _context7.t1;
                throw new UALAnchorError_1.UALAnchorError(message, type, cause);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 15]]);
      }));
    }
  }, {
    key: "extractAccountKeys",
    value: function extractAccountKeys(account) {
      console.log("extractAccountKeys", account);
      var keySubsets = account.permissions.map(function (permission) {
        return permission.required_auth.keys.map(function (key) {
          return key.key;
        });
      });
      var keys = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keySubsets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var keySubset = _step.value;
          keys = keys.concat(keySubset);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return keys;
    }
  }]);

  return AnchorUser;
}(universal_authenticator_library_1.User);

exports.AnchorUser = AnchorUser;